// src/MazeBoard.js
import React, { useState, useEffect, useRef } from 'react';
import { generateMaze, solveMaze } from './mazeLogic';

const MazeBoard = ({ onAddToBook, seed = null, difficulty = 'medium' }) => {
  const [mazeData, setMazeData] = useState(null);
  const [currentSeed, setCurrentSeed] = useState(seed || Date.now().toString());
  const [showSolution, setShowSolution] = useState(false);
  const canvasRef = useRef(null);

  // ????? ?????? ??????? ?? ?????? (????? ???????)
  const FIXED_DISPLAY_WIDTH = 350; 

  const createMaze = (newSeed = null) => {
    const s = newSeed || currentSeed;
    if (newSeed) setCurrentSeed(newSeed);

    // ????? ??????? ????? ??? ???????
    const data = generateMaze(difficulty, s);
    setMazeData(data);
    setShowSolution(false);
  };

  useEffect(() => {
    createMaze(seed); // ????? ??????? ??? ????? ??????? ?? ??? seed
  }, [difficulty, seed]);

  const handleNewMaze = () => {
    createMaze(Date.now().toString());
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !mazeData) return;
    
    const ctx = canvas.getContext('2d');
    const { maze, width, height } = mazeData;
    
    // ???? ??? ?????? (cellSize) ???????????? ????? ????? ????? ??????
    const cellSize = FIXED_DISPLAY_WIDTH / width;
    canvas.width = FIXED_DISPLAY_WIDTH;
    canvas.height = height * cellSize;

    // ??? ???????
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    
    // 1. ??? ???? (??? ??? ????)
    if (showSolution) {
      const path = solveMaze(mazeData);
      ctx.beginPath();
      ctx.strokeStyle = '#ff7675';
      ctx.lineWidth = cellSize / 2.5;
      
      if (path.length > 0) {
        ctx.moveTo(path[0].x * cellSize + cellSize/2, path[0].y * cellSize + cellSize/2);
        for (let cell of path) {
          ctx.lineTo(cell.x * cellSize + cellSize/2, cell.y * cellSize + cellSize/2);
        }
      }
      ctx.stroke();
    }

    // 2. ??? ???????
    ctx.strokeStyle = '#2d3436';
    // ?? ??????? ?????? (Expert)? ???? ???? ??? ???? ??????? ????
    ctx.lineWidth = difficulty === 'expert' || difficulty === 'hard' ? 1 : 2;
    ctx.beginPath();

    for (let y = 0; y < height; y++) {
      for (let x = 0; x < width; x++) {
        const cell = maze[y][x];
        const px = x * cellSize;
        const py = y * cellSize;

        if (cell.top) { ctx.moveTo(px, py); ctx.lineTo(px + cellSize, py); }
        if (cell.right) { ctx.moveTo(px + cellSize, py); ctx.lineTo(px + cellSize, py + cellSize); }
        if (cell.bottom) { ctx.moveTo(px + cellSize, py + cellSize); ctx.lineTo(px, py + cellSize); }
        if (cell.left) { ctx.moveTo(px, py + cellSize); ctx.lineTo(px, py); }
      }
    }
    ctx.stroke();

    // ???? ??????? (????) ???????? (????)
    ctx.fillStyle = '#00b894'; 
    ctx.beginPath(); ctx.arc(cellSize/2, cellSize/2, cellSize/3.5, 0, 2 * Math.PI); ctx.fill();
    
    ctx.fillStyle = '#d63031';
    ctx.beginPath(); ctx.arc((width-1)*cellSize + cellSize/2, (height-1)*cellSize + cellSize/2, cellSize/3.5, 0, 2 * Math.PI); ctx.fill();

  }, [mazeData, showSolution]);

  const handleAddToBook = () => {
    if (canvasRef.current) {
      const wasShowing = showSolution;
      setShowSolution(false);

      setTimeout(() => {
        const imgData = canvasRef.current.toDataURL('image/png');
        onAddToBook('Maze', imgData, { seed: currentSeed, difficulty });
        if (wasShowing) setShowSolution(true);
      }, 50);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '10px' }}>
      {!seed && (
        <div style={{marginBottom:'15px', display:'flex', gap:'10px', background:'white', padding:'10px', borderRadius:'10px', boxShadow:'0 2px 5px rgba(0,0,0,0.1)'}}>
           <button onClick={handleNewMaze} style={{background:'#6c5ce7', color:'white', border:'none', padding:'8px 15px', borderRadius:'5px', cursor:'pointer', fontWeight:'bold'}}>?? New</button>
           
           <button 
             onClick={() => setShowSolution(!showSolution)} 
             style={{
               background: showSolution ? '#e17055' : '#00b894', 
               color: 'white', border: 'none', padding:'8px 15px', borderRadius:'5px', cursor:'pointer', fontWeight:'bold'
             }}
           >
             {showSolution ? 'Hide Solution' : 'Show Solution'}
           </button>

           <button onClick={handleAddToBook} style={{background:'#e67e22', color:'white', border:'none', padding:'8px 15px', borderRadius:'5px', cursor:'pointer', fontWeight:'bold'}}>?? Add to Book</button>
        </div>
      )}

      <div style={{padding:'10px', background:'white', borderRadius:'10px', boxShadow:'0 4px 10px rgba(0,0,0,0.1)'}}>
         <canvas ref={canvasRef} />
      </div>
      <div style={{marginTop: '5px', fontSize: '12px', color: '#636e72'}}>
        Level: <strong>{difficulty.toUpperCase()}</strong>
      </div>
    </div>
  );
};

export default MazeBoard;